module.exports = {
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
        escapeValue: false // react already safes from xss
    },
    namespaceSeparator: false,
    // Considérer les chaines de charactères vide d'un fichier de translation comme invalide et utiliser le fallback dans ce cas là au lieu d'afficher la chaine vide.
    returnEmptyString: false,
}